module.exports = __webpack_public_path__ + "img/11.0e5aba69.jpg";